import { defineAttrs as e } from "../../utils/typed-attrs.js";
import { stylable as t } from "../decorators/stylable.js";
import "../decorators.js";
//#region src/specs/nodes/list-spec.ts
var n = e({ type: { default: "orderedList" } }), r = e({ type: { default: "unorderedList" } }), i = t({
	content: "listItem+",
	attrs: n,
	group: "list",
	parseDOM: [{ tag: "ol" }],
	toDOM() {
		return ["ol", 0];
	}
}), a = t({
	content: "listItem+",
	attrs: r,
	group: "list",
	parseDOM: [{ tag: "ul" }],
	toDOM() {
		return ["ul", 0];
	}
}), o = {
	content: "paragraph",
	group: "listItem",
	parseDOM: [{ tag: "li" }],
	toDOM() {
		return ["li", 0];
	},
	defining: !0
}, s = e({ type: { default: "orderedNestedList" } }), c = e({ type: { default: "unorderedNestedList" } }), l = {
	content: "nestedListItem+",
	attrs: s,
	group: "list",
	parseDOM: [{ tag: "ol" }],
	toDOM() {
		return ["ol", 0];
	}
}, u = {
	content: "nestedListItem+",
	attrs: c,
	group: "list",
	parseDOM: [{ tag: "ul" }],
	toDOM() {
		return ["ul", 0];
	}
}, d = {
	content: "block (block | list)*",
	defining: !0,
	parseDOM: [{ tag: "li" }],
	toDOM() {
		return ["li", 0];
	}
};
//#endregion
export { o as listItemSpec, d as nestedListItemSpec, i as orderedListSpec, l as orderedNestedListSpec, a as unorderedListSpec, u as unorderedNestedListSpec };
